module.exports = function (_, $, M) {
  'use strict';

  M.courses = {
    unenroll_press: function () {
      var course_id = $(this).dataAttr('course-id');

      M.modal.yes_no(
        _t('Quit this course'),
        M.trans.quitCourse,
        function () {
          M.courses.unenroll(course_id);
        },
      );

      return false;
    },

    unenroll: function (course_id) {
      $.ajax({
        url: '/ajax/courses/quit/',
        data: { course_id: course_id },
        type: 'POST',
        success: function (response) {
          if (response.success) {
            _(M.courses).emit('unenrolled', [course_id]);
          }
        },
      });
    },
  };

  M.renderer.ready(function () {
    $(document).on(
      'click',
      '[data-role="course-unenroll"]',
      M.courses.unenroll_press,
    );
  });
};
